export const getToken = () => {
  return localStorage.getItem("token")?.trim();
};

export const getUserFromToken = () => {
  const token = getToken();

  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload;
  } catch (error) {
    return null;
  }
};

export const isOwner = () => {
  const user = getUserFromToken();
  return user?.role === "owner";
};

export const isLoggedIn = () => {
  return !!getUserFromToken();
};